import React, { memo } from "react";
import { useQueries } from "react-query";
import axios from "axios";
import RegisterForm from "./RegisterForm";
import styled from "styled-components";
import { CircularProgress } from "@mui/material";

const CenteredContainer = styled.div`
  display: flex;
  height: 100vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const fetchFields = async () => {
  const { data } = await axios.get(
    "https://meeting-registration.herokuapp.com/api/public/registration/fields"
  );
  return data;
};

const fetchApartments = async () => {
  const { data } = await axios.get(
    "https://meeting-registration.herokuapp.com/api/public/registration/apartments?isAvailableOnly=true"
  );
  return data;
};

const App = () => {
  return <RegisterForm />;
};

export default memo(App);
